import { VpSkeleton, VpSkeletonVariantStyle } from '@vtmn-play/react'

type Props = {
  skeletonCount: number
  skeletonHeight?: number
  variantStyle?: VpSkeletonVariantStyle
}

const FamilyCardListSkeleton = ({
  skeletonCount,
  skeletonHeight = 150,
  variantStyle = 'regular',
}: Props) => {
  return (
    <>
      {Array.from({ length: skeletonCount }, () => crypto.randomUUID()).map((key) => (
        <VpSkeleton
          className="w-full"
          key={key}
          variant="graphic"
          shape="squared"
          variantStyle={variantStyle}
          style={{ minHeight: `${skeletonHeight}px` }}
        />
      ))}
    </>
  )
}

export default FamilyCardListSkeleton
